/* LED-Messestand – Preislogik (Stückliste + Preise).
   Gemeinsame Quelle für den Konfigurator im Theme (assets/ledup-pricing.js) und den
   Angebots-Server (src/pricing.js). Änderungen IMMER hier im Server machen und danach mit
   `npm run sync-theme` ins Theme kopieren – so rechnen Seite und Angebot identisch.

   Preise: Listenpreise (LP) netto laut Lieferanten-Preislisten 01-2025 (Rahmen) und 06-2025 (Counter).
   Kundensichtbare Texte sind bewusst neutral (Whitelabel), die Lieferanten-Artikelnummern
   stehen nur im Feld "sku" (für die Bestellung). Achtung: Diese Datei ist als Theme-Asset
   öffentlich abrufbar – keine internen Einkaufspreise oder Namen eintragen. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.LedupPricing = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var HEIGHT = 248; // Rahmenhöhe in cm

  // philips: auf diese Artikel wird die LED-Patentgebühr aufgeschlagen (laut Preisliste)
  var ITEMS = {
    'BLUP-stele-088': { lp: 863.00, philips: true, w: 88, h: true },
    'BLUP-stele-100': { lp: 863.00, philips: true, w: 100, h: true },
    'BLUP-200': { lp: 1480.00, philips: true, w: 200, h: true },
    'BLUP-300': { lp: 2010.00, philips: true, w: 300, h: true },
    'BLUP-400': { lp: 2350.00, philips: true, w: 400, h: true },
    'BLUP-500': { lp: 2880.00, philips: true, w: 500, h: true },
    'BLUP-R-600': { lp: 3640.00, philips: true, w: 600, h: true },
    // Sonderlängen (Preisliste 01-2025, LP)
    'BLUP-R-700': { lp: 4170.00, philips: true, w: 700, h: true },
    'BLUP-R-800': { lp: 4510.00, philips: true, w: 800, h: true },
    'BLUP-R-900': { lp: 5040.00, philips: true, w: 900, h: true },
    'BLUP-R-1000': { lp: 5190.00, philips: true, w: 1000, h: true },
    'BLUP-ext-75': { lp: 297.00, w: 75, h: true },
    'BLUP-ext-85': { lp: 340.00, w: 85, h: true },
    'BLUP-conn-90': { lp: 110.00 },
    'BLUP-conn-T': { lp: 125.00 },
    'BLUP-Door': { lp: 1250.00, h: true },
    'BLUP-br-200': { lp: 2061.00, philips: true, h: true },
    'BLUP-TV': { lp: 350.00, h: true },
    'BLUP-TV-tens': { lp: 66.00 },
    'LGO-counter-s': { lp: 588.00, philips: true },
    'LUP-c-one': { lp: 953.00, philips: true }
  };

  // Durchgehender Rahmen je volle Meter
  var FRAME_BY_M = { 1: 'BLUP-stele-100', 2: 'BLUP-200', 3: 'BLUP-300', 4: 'BLUP-400', 5: 'BLUP-500', 6: 'BLUP-R-600', 7: 'BLUP-R-700', 8: 'BLUP-R-800', 9: 'BLUP-R-900', 10: 'BLUP-R-1000' };
  var MAX_BREITE = 10;   // 2–6 m Standard, 7–10 m Sonderlänge

  var GROUPS = { frame: 'Rahmen & Wände', parts: 'Verbinder & Systemteile', equip: 'Ausstattung', print: 'Druck' };

  function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }

  function clampInt(v, min, max, dflt) {
    var n = parseInt(v, 10);
    if (!isFinite(n)) return dflt;
    return Math.min(max, Math.max(min, n));
  }

  function maxTiefeFor(breite) { return breite >= 6 ? 6 : breite >= 4 ? 5 : 3; }
  // Wie viele Theken passen nebeneinander in den Stand (je 100 cm + Abstand)
  function maxThekenFor(breite) { return breite >= 4 ? 3 : breite >= 3 ? 2 : 1; }

  /* Eingaben absichern – dieselben Regeln wie im Konfigurator */
  function normalize(c) {
    c = c || {};
    var typ = ['kopf', 'reihe', 'eck'].indexOf(c.typ) >= 0 ? c.typ : 'kopf';
    var breite = clampInt(c.breite, 2, MAX_BREITE, 3);
    var maxT = maxTiefeFor(breite);
    var tiefe = typ === 'kopf' ? 0 : clampInt(c.tiefe, 1, maxT, typ === 'eck' ? 3 : 1);
    var theke = ['none', 'counter', 'one'].indexOf(c.theke) >= 0 ? c.theke : 'none';
    var maxTh = maxThekenFor(breite);
    var kabine = !!c.kabine && typ !== 'kopf' && breite >= 3;
    return {
      typ: typ,
      breite: breite,
      tiefe: tiefe,
      maxTiefe: maxT,
      theke: theke,
      thekeAnzahl: theke === 'none' ? 0 : clampInt(c.thekeAnzahl, 1, maxTh, 1),
      maxTheken: maxTh,
      kabine: kabine,
      // Kabine 1 × 2 m: Seitenrahmen verlängert, Tür 1 m weiter vorn – braucht mind. 2 m Standtiefe
      kabineTiefe: kabine && tiefe >= 2 && parseInt(c.kabineTiefe, 10) === 2 ? 2 : 1,
      bruecke: !!c.bruecke,
      tv: !!c.tv
    };
  }

  /* Eine Wand der Länge m (Meter) mit 0, 1 oder 2 Ecken.
     Ecke: Rahmen um 15 cm kürzer (Profiltiefe + Verbinder), Reihenstand-Rückwand (2 Ecken) um 25 cm. */
  function wallParts(m, corners) {
    if (corners === 0) return [FRAME_BY_M[m]];
    if (m === 1) return ['BLUP-stele-088'];
    return [FRAME_BY_M[m - 1], corners === 2 ? 'BLUP-ext-75' : 'BLUP-ext-85'];
  }

  function walls(k) {
    if (k.typ === 'kopf') return [{ name: 'Rückwand', m: k.breite, corners: 0 }];
    if (k.typ === 'eck') {
      return [
        { name: 'Rückwand', m: k.breite, corners: 1 },
        { name: 'Seitenwand', m: k.tiefe, corners: 1 }
      ];
    }
    return [
      { name: 'Rückwand', m: k.breite, corners: 2 },
      { name: 'Seitenwand links', m: k.tiefe, corners: 1 },
      { name: 'Seitenwand rechts', m: k.tiefe, corners: 1 }
    ];
  }

  function sku(code) { return ITEMS[code].h ? code + '-' + HEIGHT : code; }

  function title(code) {
    var it = ITEMS[code];
    if (/^BLUP-(stele-|R-)?\d/.test(code)) return 'LED-Leuchtrahmen ' + it.w + ' × ' + HEIGHT + ' cm, inkl. Transportkoffer';
    if (code.indexOf('BLUP-ext-') === 0) return 'Erweiterungsmodul +' + it.w + ' cm für LED-Leuchtrahmen, Höhe ' + HEIGHT + ' cm';
    return {
      'BLUP-conn-90': 'Eckverbinder-Set 90° (oben & unten)',
      'BLUP-conn-T': 'T-Verbinder-Set (oben & unten)',
      'BLUP-Door': 'Kabinentür, Höhe ' + HEIGHT + ' cm, inkl. 2 Transportkoffer',
      'BLUP-br-200': 'LED-Brücke 100 cm breit, 2 m Ausleger, Höhe ' + HEIGHT + ' cm, inkl. 2 Transportkoffer',
      'BLUP-TV': 'TV-Halter für Monitore bis 10 kg (VESA 200/400), inkl. Tasche',
      'BLUP-TV-tens': 'TV-Abspannkit für zusätzliche Stabilität',
      'LGO-counter-s': 'LED-Counter (B 100 × H 100 × T 40 cm), Thekenplatte silber, inkl. Transportkoffer',
      'LUP-c-one': 'LED-Counter One mit Stauraum (B 100 × H 100 × T 44 cm), Thekenplatte schwarz, inkl. Transportkoffer'
    }[code];
  }

  /* Hauptfunktion: Stückliste + Preise für eine Konfiguration.
     settings: { philipsFeePct: 3, textileSqm: 36, blockoutSqm: 36, vatPct: 19 } */
  function quote(config, settings) {
    var s = settings || {};
    var fee = Math.max(0, parseFloat(s.philipsFeePct) || 0) / 100;
    var textile = Math.max(0, parseFloat(s.textileSqm) || 0);
    var blockout = Math.max(0, parseFloat(s.blockoutSqm) || 0);
    var vatPct = s.vatPct == null ? 19 : Math.max(0, parseFloat(s.vatPct) || 0);
    var k = normalize(config);

    // lines: flache, zusammengefasste Liste (für Shopify-Entwurf / Bestellung)
    // positions: Hauptpositionen mit Unterpositionen (für Kunden-Mail und PDF)
    var lines = [];
    var byKey = {};
    var positions = [];
    var current = null;

    function add(line) {
      if (current) current.items.push(Object.assign({}, line));
      var key = line.sku + '|' + line.title + '|' + line.unitNet;
      if (byKey[key]) { byKey[key].qty += line.qty; return; }
      byKey[key] = Object.assign({}, line);
      lines.push(byKey[key]);
    }
    function position(title) { current = { title: title, items: [] }; positions.push(current); }
    function product(code, qty, group) {
      var it = ITEMS[code];
      add({
        sku: sku(code), title: title(code), qty: qty || 1, group: group,
        unitNet: round2(it.lp * (it.philips ? 1 + fee : 1)), kind: 'product'
      });
    }
    function print(kind, wCm, hCm, qty, note) {
      var rate = kind === 'textile' ? textile : blockout;
      var area = (wCm / 100) * (hCm / 100);
      var billed = Math.max(1, area); // Mindestpreis: 1 m² pro Druck
      add({
        sku: kind === 'textile' ? 'DRUCK-TEXTIL' : 'DRUCK-BLOCKOUT',
        title: (kind === 'textile' ? 'Textildruck ' : 'Blockout-Rückseite schwarz ') + wCm + ' × ' + hCm + ' cm' + (note ? ' (' + note + ')' : ''),
        qty: qty || 1, group: 'print', unitNet: round2(billed * rate), kind: kind,
        areaSqm: Math.round(area * 1000) / 1000
      });
    }
    // Jeder Rahmen: vorne Textildruck, hinten schwarzes Blockout
    function framePrints(wCm) { print('textile', wCm, HEIGHT, 1, 'vorne'); print('blockout', wCm, HEIGHT, 1, 'hinten'); }

    // 1) Wände – je Wand eine Position: Rahmen + Erweiterung + Drucke
    var wallInfo = walls(k).map(function (w) {
      var parts = wallParts(w.m, w.corners);
      var widthCm = parts.reduce(function (a, c) { return a + ITEMS[c].w; }, 0);
      position('LED-Leuchtwand ' + widthCm + ' × ' + HEIGHT + ' cm – ' + w.name);
      parts.forEach(function (c) { product(c, 1, c.indexOf('-ext-') > 0 ? 'parts' : 'frame'); });
      framePrints(widthCm);
      return { name: w.name, m: w.m, widthCm: widthCm, parts: parts.map(sku) };
    });

    // 2) Ecken
    var corners = k.typ === 'eck' ? 1 : k.typ === 'reihe' ? 2 : 0;
    if (corners) { position(title('BLUP-conn-90')); product('BLUP-conn-90', corners, 'parts'); }

    // 3) Kabine: Rahmen im 90°-Winkel zur Rückwand (T-Verbinder) + Tür.
    //    1 m tief: 88er-Rahmen · 2 m tief: Rahmen wie eine 2-m-Seitenwand (100 + 85 cm Erweiterung)
    if (k.kabine) {
      var kabParts = wallParts(k.kabineTiefe, 1);
      var kabCm = kabParts.reduce(function (a, c) { return a + ITEMS[c].w; }, 0);
      position('Kabine 1 × ' + k.kabineTiefe + ' m mit Tür');
      kabParts.forEach(function (c) { product(c, 1, c.indexOf('-ext-') > 0 ? 'parts' : 'frame'); });
      product('BLUP-conn-T', 1, 'parts');
      product('BLUP-Door', 1, 'equip');
      framePrints(kabCm);
      print('textile', 100, HEIGHT, 1, 'Tür vorne');
      print('blockout', 100, HEIGHT, 1, 'Tür hinten');
    }

    // 4) Brücke
    if (k.bruecke) {
      position('LED-Brücke 100 cm breit, 2 m Ausleger');
      product('BLUP-br-200', 1, 'equip');
      print('textile', 100, HEIGHT, 1, 'Säule vorne');
      print('blockout', 100, HEIGHT, 1, 'Säule hinten');
      print('textile', 100, 200, 1, 'Ausleger');
    }

    // 5) TV-Halter – ohne Ecke (Kopfstand oder an der freistehenden Brücke) mit Abspannkit
    if (k.tv) {
      position('TV-Halter');
      product('BLUP-TV', 1, 'equip');
      if (k.typ === 'kopf' || k.bruecke) product('BLUP-TV-tens', 1, 'equip');
    }

    // 6) Theke (1–3 Stück)
    var nTh = k.thekeAnzahl || 1;
    var thPrefix = nTh > 1 ? nTh + ' × ' : '';
    if (k.theke === 'counter') {
      position(thPrefix + title('LGO-counter-s').replace(', inkl. Transportkoffer', ''));
      product('LGO-counter-s', nTh, 'equip');
      print('textile', 100, 100, 2 * nTh, 'vorne & hinten');
    } else if (k.theke === 'one') {
      position(thPrefix + title('LUP-c-one').replace(', inkl. Transportkoffer', ''));
      product('LUP-c-one', nTh, 'equip');
      print('textile', 100, 100, nTh, 'vorne');
      print('blockout', 100, 100, nTh, 'hinten');
      print('textile', 32, 100, 2 * nTh, 'Seiten'); // Mindestpreis 1 m²
    }
    current = null;

    positions.forEach(function (p) {
      p.items.forEach(function (i) { i.totalNet = round2(i.unitNet * i.qty); });
      p.totalNet = round2(p.items.reduce(function (a, i) { return a + i.totalNet; }, 0));
      // Position aus nur einem Artikel (z. B. Eckverbinder 2 ×): Menge/Einzelpreis direkt zeigen
      p.qty = p.items.length === 1 ? p.items[0].qty : 1;
      p.unitNet = p.items.length === 1 ? p.items[0].unitNet : p.totalNet;
    });

    // Reihenfolge: Rahmen, Systemteile, Ausstattung, Druck
    var order = { frame: 0, parts: 1, equip: 2, print: 3 };
    lines.sort(function (a, b) { return order[a.group] - order[b.group]; });
    lines.forEach(function (l) {
      l.totalNet = round2(l.unitNet * l.qty);
      l.groupLabel = GROUPS[l.group];
    });

    var netTotal = round2(lines.reduce(function (a, l) { return a + l.totalNet; }, 0));
    var vat = round2(netTotal * vatPct / 100);
    var reprintNet = round2(lines.filter(function (l) { return l.kind === 'textile'; })
      .reduce(function (a, l) { return a + l.totalNet; }, 0));

    var typName = k.typ === 'eck' ? 'Eckstand' : k.typ === 'reihe' ? 'Reihenstand' : 'Kopfstand';
    var hoehe = String(HEIGHT / 100).replace('.', ',') + ' m hoch';
    var masz = k.typ === 'kopf'
      ? k.breite + ' m ' + typName + ' · ' + hoehe
      : k.breite + ' × ' + k.tiefe + ' m ' + typName + ' · ' + hoehe;
    var wallM = k.typ === 'kopf' ? k.breite : k.typ === 'eck' ? k.breite + k.tiefe : k.breite + 2 * k.tiefe;

    var extras = [];
    if (k.theke === 'one') extras.push(thPrefix + 'Counter One');
    if (k.theke === 'counter') extras.push(thPrefix + 'Counter');
    if (k.bruecke) extras.push('Brücke');
    if (k.kabine) extras.push('Kabine 1 × ' + k.kabineTiefe + ' m');
    if (k.tv) extras.push('TV-Halter');

    return {
      config: k,
      lines: lines,
      positions: positions,
      walls: wallInfo,
      netTotal: netTotal,
      vatPct: vatPct,
      vat: vat,
      grossTotal: round2(netTotal + vat),
      reprintNet: reprintNet,
      typName: typName,
      masz: masz,
      wallSqm: Math.round(wallM * HEIGHT) / 100,
      extras: extras,
      settings: { philipsFeePct: fee * 100, textileSqm: textile, blockoutSqm: blockout, vatPct: vatPct }
    };
  }

  /* Konfiguration als kurzer, lesbarer URL-Wert: eck-5x3-one2-br-kab2-tv
     (Link „Konfiguration speichern“, Vorlagen auf der Seite, Sitelinks in Google Ads) */
  function encodeKonfig(c) {
    var k = normalize(c);
    var parts = [k.typ, k.typ === 'kopf' ? String(k.breite) : k.breite + 'x' + k.tiefe];
    if (k.theke !== 'none') parts.push(k.theke + (k.thekeAnzahl || 1));
    if (k.bruecke) parts.push('br');
    if (k.kabine) parts.push('kab' + (k.kabineTiefe || 1));
    if (k.tv) parts.push('tv');
    return parts.join('-');
  }
  function decodeKonfig(str) {
    var t = String(str || '').toLowerCase().replace(/[^a-z0-9x-]/g, '').split('-');
    if (['kopf', 'reihe', 'eck'].indexOf(t[0]) < 0) return null;
    var c = { typ: t[0] };
    var m = /^(\d{1,2})(?:x(\d))?$/.exec(t[1] || '');
    if (m) { c.breite = +m[1]; if (m[2]) c.tiefe = +m[2]; }
    t.slice(2).forEach(function (x) {
      var mm;
      if ((mm = /^(counter|one)([1-3])?$/.exec(x))) { c.theke = mm[1]; c.thekeAnzahl = +(mm[2] || 1); }
      else if (x === 'br') c.bruecke = true;
      else if ((mm = /^kab([12])?$/.exec(x))) { c.kabine = true; c.kabineTiefe = +(mm[1] || 1); }
      else if (x === 'tv') c.tv = true;
    });
    return normalize(c);
  }

  return {
    MAX_BREITE: MAX_BREITE, quote: quote, normalize: normalize, maxTiefeFor: maxTiefeFor, maxThekenFor: maxThekenFor,
    encodeKonfig: encodeKonfig, decodeKonfig: decodeKonfig, HEIGHT: HEIGHT, ITEMS: ITEMS
  };
});
